import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "carousel-title" }
const _hoisted_4 = {
  text: "2xl",
  justify: "center"
}
const _hoisted_5 = {
  key: 1,
  class: "card",
  style: {"width":"100%","display":"flex","flex-direction":"row","justify-content":"space-around"}
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]

import { ref, reactive, onMounted } from 'vue';
import { friendlyLink } from '@/pubilc/data';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'swiper',
  props: {
  isChooseType: {
    type: String,
    default: ''
  },
  list: {
    type: Array,
    default: () => [] // 修改默认值为空数组
  }
},
  setup(__props) {

const props = __props

// 检查列表数据是否有效
// const validList = computed(() => {
//   return props.list.filter(item => item && item.img); // 确保item和item.img存在
// });

// 配置Swiper选项
// const swiperOptions = reactive({
//   loop: true, // 开启循环模式
//   slidesPerView: 5, // 设置每屏显示的slides数量，可以根据需要调整
//   spaceBetween: 30, // 设置slides之间的间距
//   autoplay: { // 自动播放参数设置（可选）
//     delay: 7000, // 自动切换时间间隔
//     disableOnInteraction: false, // 用户操作后是否继续自动播放
//   },
// })

// 查看文章
const checkDetail = (item: any) => {
  if (item.id) { // 确保有id才跳转
    router.push({
      path: '/article',
      query: {
        id: item.id
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isChooseType == 1)
      ? (_openBlock(), _createBlock(_component_el_carousel, {
          key: 0,
          "indicator-position": "outside",
          class: "custom-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: i,
                onClick: ($event: any) => (checkDetail(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: "",
                      class: "carousel-image"
                    }, null, 8, _hoisted_2)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isChooseType == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(friendlyLink), (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "slide",
              key: i,
              style: {"margin":"0 5px"}
            }, [
              _createElementVNode("a", {
                href: item.link,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  style: {"width":"100%","height":"6vh"},
                  src: item.image,
                  alt: ""
                }, null, 8, _hoisted_7)
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})